export default {
      id: "ic_spor_toto_transfer-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_spor_toto_transfer-usage",
      toString: function () {
        return this.url;
      }
    }